module.exports = __webpack_public_path__ + "static/media/mill-behind.b4e80dcb.svg";